export default function trackUTMParams() {
	console.log("trackUTMParams initialized");

	function getQueryParams() {
		console.log("getQueryParams called");
		const params = new URLSearchParams(window.location.search);
		let utmData = {};
		const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

		utmKeys.forEach((key) => {
			if (params.has(key)) {
				utmData[key] = params.get(key);
			}
		});

		return utmData;
	}

	function storeUTMParams() {
		console.log("storeUTMParams called");
		if (!localStorage.getItem("utm_params")) {
			let utmData = getQueryParams();

			if (Object.keys(utmData).length > 0) {
				localStorage.setItem("utm_params", JSON.stringify(utmData));
			}
		}
	}

	storeUTMParams();
}
